export default "__VITE_ASSET__D$XfYZ7k__"